<template>
	<div data-tour-scope="setting-listings">
		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.listing') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-btn text data-tour="filters" @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>

								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi listino</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>


						<v-card v-if="selected.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selected.length }}
									<span v-if="selected.length == 1" class="ml-1"> selezionato </span>
									<span v-else class="ml-1"> selezionati </span>
								</v-tab>

								<v-tab @click="duplicateItem" v-if="selected.length == 1"> duplica </v-tab>
								<v-tab @click="editItem" v-if="selected.length == 1"> modifica </v-tab>
								<v-tab @click="anagraficaItem" v-if="selected.length == 1"> anagrafica prodotti </v-tab>
								<v-tab @click="anagraficaUser" v-if="selected.length == 1"> gestione utenti </v-tab>
								<v-tab @click="deleteItem"> elimina </v-tab>
							</v-tabs>
						</v-card>

						<v-data-table
							v-model="selectedall"
							:headers="headers"
							:items="getListings"
							:options.sync="settings.options"
							:server-items-length="total"
							@input="toggle"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							data-tour="table"
							show-select
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="listing-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card :title="item.name || 'Listino'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-checkbox class="mt-0 pt-0" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Status</span>
													<v-switch v-model="item.status" data-tour="switch" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="`${item.id}${_.random(1, 10000)}`">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->
										<td>
											<v-checkbox class="mt-0" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
										</td>
										<td>
											<v-switch v-model="item.status" data-tour="switch" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>

										<td>{{ item.name }}</td>
										<td>{{ item.percent }}</td>
										<td>{{ _.size(item.items) }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<!--<v-btn
                            fab
                            bottom
                            right
                            color="secondary"
                            dark
                            fixed
                            @click.prevent="openNew()"
                    >

                        <v-icon>add</v-icon>
                    </v-btn>-->
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormEdit v-if="operation == 'FormEdit'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation == 'FormCreate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormCreate>
			<FormDuplicate v-if="operation == 'FormDuplicate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormDuplicate>
			<!--<FormItem v-if="operation=='FormItem'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormItem>-->
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando l'operazione, non sarà più possibile ripristinare i dati </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createListingsTourSteps } from './listings-tour';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';

Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

const FormCreate = () => import('@/components/listings/Create.vue');
const FormEdit = () => import('@/components/listings/Edit.vue');
const FormDuplicate = () => import('@/components/listings/Duplicate.vue');
/*const FormItem = () => import('@/components/listings/Item.vue');*/

export default {
	name: 'Listing',
	setup() {
		return { tour: useTour(createListingsTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',

			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					firstlevel: '',
					secondlevel: '',
					thirdlevel: '',
					fourthlevel: '',
					categories: [],
				},
				options: {
					sortBy: ['id'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],

			searchfield: '',
			selected: [],
			selectedall: [],

			total: 0,

			headers: [
				{ text: 'Status', value: 'status' },
				//{text: 'Id', value: 'id'},

				{ text: 'Name', value: 'name' },
				{ text: 'Discount', value: 'percent' },
				{ text: 'Items', value: 'items' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},

			firstLevel: [],
			secondLevel: [],
			thirdLevel: [],
			fourthLevel: [],
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,

			isMobile: false,

			operation: '',
			magento: false,
			langDefault: '',
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},

	async created() {
		this.setDialog(false);
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}nocors/categories/download`;
		this.destroyCustomer();
		await this.fetchSetting();
		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
	},
	watch: {
		selectedLength(val, oldVal) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		settings: {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] != '') {
					var outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}

				if (val.options.page == this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.options.page;
				this.getDataFromApi();
			},
			deep: true,
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		TourOverlay,
		KeyValueCard,
		FormCreate,
		FormEdit,
		FormDuplicate,
		//FormItem

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selected.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'categories/getIndex',
			getListings: 'listings/getListings',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'categories/getSortBy',
			getSortDesc: 'categories/getSortDesc',
			getSettings: 'settings/getSetting',
		}),
		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [
				{ label: 'Discount', value: item.percent, strong: true },
				{ label: 'Items', value: _.size(item.items) },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setListings: 'listings/setListings',
			setListing: 'listings/setListing',
			setIndex: 'listings/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'listings/asyncFetchData',

			destroyData: 'listings/destroyData',
			destroyCustomer: 'customers/destroyData',
			saveData: 'users/saveData',

			setUpdateStatusListing: 'listings/setUpdateStatusListing',
			deleteListings: 'listings/deleteListings',
			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		filterCheck(event) {
			var dot = _.map(event, 'id');

			this.settings.filters.categories = dot;
		},
		toggle(event) {
			if (_.size(this.selectedall) == 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] != -1) {
					this.selected = [];
					_.forEach(this.getListings, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggleDrawerSort() {
			this.setDrawerFilter(0);
			this.clippedOrder = !this.clippedOrder;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		changeStatus(item) {
			try {
				this.setPreload(true);
				this.isActive = true;

				let items = this.setUpdateStatusListing({ _id: item._id, status: item.status }).then(result => {
					//this.total = result.total
					//this.items = result.data.data
					if (result.data.data.ok) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async anagraficaItem() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)

			this.operation = 'FormItem';
			var item = _.find(this.getListings, search => {
				return search._id == this.selected[0];
			});

			this.setIndex(this.getListings.indexOf(item));
			this.$router.push(`/listings/${item._id}/items`);
			/*this.setListing(item);
                this.setMessages();
                this.setDialog(true);
                this.setSnackbar(false);*/
		},
		async anagraficaUser() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormItem';
			var item = _.find(this.getListings, search => {
				return search._id == this.selected[0];
			});

			this.setIndex(this.getListings.indexOf(item));
			this.$router.push(`/listings/${item._id}/users`);
		},

		async editItem() {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormEdit';
			var item = _.find(this.getListings, search => {
				return search._id == this.selected[0];
			});
			this.setIndex(this.getListings.indexOf(item));
			this.setListing(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async duplicateItem() {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormDuplicate';
			var item = _.find(this.getListings, search => {
				return search._id === this.selected[0];
			});
			this.setIndex(this.getListings.indexOf(item));
			this.setListing(item);

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormCreate';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
			//this.getDataFromApi()
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;

				const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;

				let items = this.fetchItems(this.settings);
				items
					.then(result => {
						this.total = result.total;
						//this.items = result.data.data
						this.setPreload(false);
						this.selected = [];
						this.selectedall = [];
					})
					.then(() => {});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
			//this.selected = [];
			// this.selectedall = []
		},
		confirmDelete() {
			this.dialogconfirm = false;
			var paypload = [];
			_.forEach(this.selected, cat => {
				var index = _.find(this.getListings, search => {
					return search._id == cat;
				});
				//console.log(index)
				if (index) {
					paypload.push(index);
				}
			});
			this.deleteListings(paypload)
				.then(data => {
					this.setPreload(false);
					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.listing-cards,
.listing-cards tr {
	display: block;
	width: 100%;
}
.listing-cards tr,
.listing-cards tr:hover {
	background: transparent !important;
}
.listing-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.listing-cards tr:first-child td {
	padding-top: 12px !important;
}
.listing-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.listing-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
